export default __webpack_public_path__ + "assembly3afefb6.png";